import { Outlet, useNavigate } from "react-router";
import {
  BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS,
  BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DOCUMENTS,
  BUSINESS_INTEGRATION_RYFT_NON_HOSTED_BALANCE,
  BUSINESS_INTEGRATION_SETTINGS,
} from "~/constants/routes";
import { PageCollectionLayout } from "~/components/pageCollection/PageCollectionLayout";
import { RyftNonHostedDashboardAccountProvider } from "./components/RyftNonHostedDashboardAccountProvider";
import { useRyftNonHostedDashboardAccount } from "./components/RyftNonHostedDashboardAccountProvider.shared";
import { RyftNonHostedVerificationStatus } from "./RyftNonHostedVerificationStatus";
import { ReactNode } from "react";

const tabs = [
  { label: "Accounts", route: BUSINESS_INTEGRATION_RYFT_NON_HOSTED_ACCOUNTS },
  { label: "Documents", route: BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DOCUMENTS },
  { label: "Balance", route: BUSINESS_INTEGRATION_RYFT_NON_HOSTED_BALANCE },
];

export const RyftNonHostedDashboardLayout = () => {
  return (
    <RyftNonHostedDashboardAccountProvider>
      <DashboardContent>
        <Outlet />
      </DashboardContent>
    </RyftNonHostedDashboardAccountProvider>
  );
};

const DashboardContent = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { account } = useRyftNonHostedDashboardAccount();

  return (
    <PageCollectionLayout
      title="Ryft"
      tabsLeft={tabs}
      onClickBack={() => navigate(BUSINESS_INTEGRATION_SETTINGS)}
      topComponent={<RyftNonHostedVerificationStatus account={account} />}
    >
      {children}
    </PageCollectionLayout>
  );
};
